<template>
  <div class="container">
    <div class="row d-flex justify-content-center mt-10 mb-10">
      <div class="col-lg-9">
        <card-component :title="$t('messages.form.title')">
          <b-card-text>
            <h1 v-if="!$root.isMobile()">
              {{ $t("messages.form.subTitle") }}
            </h1>
            <h1 v-if="$root.isMobile()">
              Formulário KYC<span> da PagBrasil</span>
            </h1>
            <p>
              {{ $t("messages.form.introduction.start") }}
              <strong>
                {{ $t("messages.form.introduction.highlight") }}
              </strong>
              {{ $t("messages.form.introduction.end") }}
            </p>
            <div class="footer row">
              <div class="col-lg-6 col-12 d-flex align-items-center p-0">
                <b-form-checkbox
                  id="checkbox-confirm"
                  v-model="confirmCheckbox"
                  name="checkbox-confirm"
                  :unchecked-value="false"
                >
                  {{ $t("messages.form.useTermsAgree") }}
                  <a
                    target="_blank"
                    href="https://www.pagbrasil.com/pt-br/termos-de-uso/"
                    >{{ $t("messages.form.useTerms") }}</a
                  >.
                </b-form-checkbox>
              </div>
              <div class="col-lg-6 col-12">
                <b-button
                  @click="$router.push('access')"
                  size="lg"
                  :class="confirmCheckbox ? 'bg-primary text-white' : ''"
                  class="float-right"
                  :disabled="!confirmCheckbox"
                  >{{ $t("buttons.createAccess") }}</b-button
                >
              </div>
            </div>
          </b-card-text>
        </card-component>
      </div>
    </div>
  </div>
</template>
<script>
import CardComponent from "@/components/Form/CardComponent";

export default {
  name: "FormPage",
  components: {
    CardComponent,
  },
  data() {
    return {
      confirmCheckbox: false,
    };
  },
  mounted() {
    let accountManagerAbbreviation = new URLSearchParams(window.location.search).get("s");
    let hash = window.location.hash;

    if (!accountManagerAbbreviation) {
        accountManagerAbbreviation = new URLSearchParams(hash.substr(hash.indexOf("?"))).get("s");
    }

    localStorage.setItem("account_manager_abbreviation", accountManagerAbbreviation);
  }
};
</script>
